import dayjs from "dayjs";
import AppContext from "../../../application/AppContext";
import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

export const DocTeamUserChangeType = {
    ADD: {
        key: "ADD",
        name: "添加",
    },
    DELETE: {
        key: "DELETE",
        name: "删除",
    },
};

export const TabType = {
    UNIT_BASIC_INFO: {
        key: "UNIT_BASIC_INFO",
        name: "科室基本信息",
    },
    UNIT_MEMBER: {
        key: "UNIT_MEMBER",
        name: "科室成员",
    },
    MEDI_GROUP_MGMT: {
        key: "MEDI_GROUP_MGMT",
        name: "科室医疗组管理",
    },
};


const initState = {
    selectedUnitIds: [],
    selectedTab: TabType.UNIT_BASIC_INFO.key,
    month: dayjs(),
    currentDataMonth: dayjs(),
    loadingCount: 0,
    countByUnit: null,
    workStatusList: [],
    unitsMap: [],
    config: null,
    chiefResidentRoleId: null,
    areaConfig: null,
    selectedUnits: [],
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
